import React, { useState } from "react";
import PropTypes from "prop-types";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { BsPerson } from "react-icons/bs";
import logo from "../../assets/persona.svg";

const Persona = ({ text, status }) => {
  const [onClick, setOnCLick] = useState(false);
  const [onSearching, setSearching] = useState(false);
  const onClickHandler = (e) => {
    setOnCLick(!onClick);
  };
  const selectHandler = () => {
    setSearching(!onSearching);
  };
  return (
    <div
      className={`${
        onClick ? "flex flex-col border-blue-700 border mr-1 h-auto" : ""
      }`}
    >
      <button
        onClick={onClickHandler}
        className="flex flex-row justify-between w-full hover:bg-gray-100"
      >
        <div className="flex items-center px-2 h-12 hover:text-blue-600 font-medium">
          <BsPerson />
          <div className="ml-2 text-sm">Persona</div>
        </div>
        <div className="m-4">
          {!onClick ? (
            <FaCaretDown className="text-gray-500" />
          ) : (
            <FaCaretUp className="text-gray-500" />
          )}
        </div>
      </button>
      {onClick && (
        <>
          <div className="pt-2 p-2">
            <div className="flex flex-col bg-gray-100 w-full h-96 rounded-sm p-4">
              <img src={logo} alt="persona" />
              <div className="flex flex-col items-center justify-center">
                <h3 className="font-semibold">Prospect Faster with Personas</h3>
                <p className="text-sm text-center text-gray-500">
                  Group different roles & seniority levels into different
                  personas to prospect faster and receive personalized
                  recommendations.
                </p>
              </div>
              <div className="flex justify-around items-center w-full">
                <button className="w-48 p-2 m-2 bg-white text-black  rounded-sm border hover:border-blue-600">
                  <div className="flex items-center justify-center">
                    <BsPerson className="text-blue-600" />
                    <p className="ml-2 text-sm">Create a Persona</p>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <hr />
    </div>
  );
};

Persona.propTypes = {};

export default Persona;
